<script lang="ts">
	export let title: string;
	export let value: string | undefined;
	export let truncateValue: boolean = false;
</script>

{#if value}
	<div class="text-bold">{title}</div>
	<div class="text-right {truncateValue && 'truncate'}">{value}</div>
{/if}
